import React from 'react';

function Spinner() {
  return (
    <div className="spinner-overlay">
      <div className="spinner-container">
        <img 
          src="assets/images/ROH.gif" 
          alt="Loading..." 
          className="spinner-image"
        />
      </div>
      <style jsx>{`
        .spinner-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }
        
        .spinner-container {
          width: 50px;
          height: 50px;
          position: relative;
        }
        
        .spinner-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      `}</style>
    </div>
  );
}

export default Spinner;